import { render } from "./AddLiveDataHeader.vue?vue&type=template&id=5e31256f"
import script from "./AddLiveDataHeader.vue?vue&type=script&lang=js"
export * from "./AddLiveDataHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__